import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { TooltipGeneral } from "components/DesignComponents/Tooltips/TooltipGeneral";
import { TOOLTIP_PLACEMENT } from "components/DesignComponents/Tooltips/types/enums";

import { DialogActionsProps } from "./types";

const DialogActions = ({
    isLoading,
    isReadyToConfirm,
    onClose,
    isCancelDisabled,
    loaderText,
    submitBtnColor,
    submitBtnTooltipText,
    confirmationButtonText,
    secondaryButtonText,
    confirmationButtonTestId,
    cancelButtonTestId
}: DialogActionsProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Button
                data-testid={cancelButtonTestId}
                fullWidth
                color={BUTTON_COLORS.Secondary}
                size={BUTTON_SIZES.Normal}
                variant={BUTTON_VARIANTS.TextOnly}
                disabled={isCancelDisabled || isLoading}
                onClick={onClose}
            >
                {secondaryButtonText ?? t("Button##close")}
            </Button>

            <TooltipGeneral
                title={submitBtnTooltipText}
                placement={TOOLTIP_PLACEMENT.Top}
            >
                <span css={css({ display: "flex" })}>
                    <Button
                        data-testid={confirmationButtonTestId ?? "save-button"}
                        fullWidth
                        color={submitBtnColor ?? BUTTON_COLORS.Primary}
                        size={BUTTON_SIZES.Normal}
                        variant={BUTTON_VARIANTS.TextOnly}
                        type="submit"
                        isLoading={isLoading}
                        loaderText={loaderText}
                        disabled={!isReadyToConfirm}
                    >
                        {confirmationButtonText ?? t("Button##save")}
                    </Button>
                </span>
            </TooltipGeneral>
        </>
    );
};

export default DialogActions;
